import { storage, StorageKeys } from '@/services/storage';

/**
 * Returns a stable ID that uniquely identifies the current browser tab for
 * the lifetime of the page session. Stored in sessionStorage so it persists
 * across component mounts/unmounts but resets when the tab is closed.
 */
export const getTabId = (): string => {
  const existing = storage.get(StorageKeys.TabId);
  if (existing) return existing;
  const id = crypto.randomUUID();
  storage.set(StorageKeys.TabId, id);
  return id;
};
